import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class ScheduleService {
    constructor(private http: HttpClient) { }

    // Get All Store Specific Schedules (ie Opening Times)
    public getStoreSchedules(id) {
        let paginationString = '';
        paginationString += '?size=' + 10000;
        paginationString += '&page=' + 0;

        return this.http
            .get(environment.apiUrl + 'api/ext-schedule/by-store/' + id + paginationString)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Get Schedule(s) for a Category
    public getCategorySchedules(id) {
        let paginationString = '';
        paginationString += '?size=' + 10000;
        paginationString += '&page=' + 0;

        return this.http
            .get(environment.apiUrl + 'api/ext-schedule/by-item-category/' + id + paginationString)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Get Delivery Schedules
    public getDeliverySchedules(id) {
        return this.http
            .get(environment.apiUrl + 'api/ext-schedule/by-delivery-store/' + id)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Get individual schedule by id
    public getScheduleById(id) {
        return this.http
            .get(environment.apiUrl + 'api/ext-schedule/' + id)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Get all schedules system wide
    public getAllSchedules() {
        return this.http
            .get(environment.apiUrl + 'api/ext-schedule')
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Create a store schedule
    public createStoreSchedule(storeid, obj) {
        const startTimeString = obj.startTimeHour + ':' + obj.startTimeMinute + ':00';
        const endTimeString = obj.endTimeHour + ':' + obj.endTimeMinute + ':00';
        const body = {
            storeId: storeid,
            dayOfWeek: obj.dayOfWeek,
            endTime: endTimeString,
            startTime: startTimeString,
            itemCategoryId: null,
            deliveryStoreId: null,
        };
        return this.http
            .post(environment.apiUrl + 'api/ext-schedule', body)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Create a category schedule
    public createCategorySchedule(catid, obj) {
        const startTimeString = obj.startTimeHour + ':' + obj.startTimeMinute + ':00';
        const endTimeString = obj.endTimeHour + ':' + obj.endTimeMinute + ':00';
        const body = {
            storeId: null,
            dayOfWeek: obj.dayOfWeek,
            endTime: endTimeString,
            startTime: startTimeString,
            itemCategoryId: catid,
            deliveryStoreId: null,
        };
        console.log('body', body);
        return this.http
            .post(environment.apiUrl + 'api/ext-schedule', body)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Create a kiosk category schedule
    public createKioskCategorySchedule(catid, obj) {
        const startTimeString = obj.startTimeHour + ':' + obj.startTimeMinute + ':00';
        const endTimeString = obj.endTimeHour + ':' + obj.endTimeMinute + ':00';
        const body = {
            storeId: null,
            dayOfWeek: obj.dayOfWeek,
            endTime: endTimeString,
            startTime: startTimeString,
            itemCategoryKioskId: catid,
            deliveryStoreId: null,
        };
        return this.http
            .post(environment.apiUrl + 'api/ext-schedule', body)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Create Delivery Schedule
    public createDeliverySchedule(storeid, obj) {
        const startTimeString = obj.startTimeHour + ':' + obj.startTimeMinute + ':00';
        const endTimeString = obj.endTimeHour + ':' + obj.endTimeMinute + ':00';
        const body = {
            storeId: null,
            dayOfWeek: obj.dayOfWeek,
            endTime: endTimeString,
            startTime: startTimeString,
            itemCategoryId: null,
            deliveryStoreId: storeid,
        };
        return this.http
            .post(environment.apiUrl + 'api/ext-schedule', body)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Edit a schedule
    public editSchedule(obj) { }

    // Delete a schedule
    public deleteSchedule(id) {
        return this.http
            .delete(environment.apiUrl + 'api/ext-schedule/' + id)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Delete a delivery schedule
    public deleteDeliverySchedule(id) {
        return this.http
            .delete(environment.apiUrl + `api/ext-schedule/${id}/?isDelivery=true`)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Get all schedules that have been 'deleted'
    public getAllDeletedSchedules() { }

    // Get a specific deleted schedule
    public getDeletedScheduleById(id) {
        return this.http
            .get(environment.apiUrl + 'api/ext-schedule/deleted/' + id)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // HANDLE DATA
    private handleData(res: HttpResponse<any>) {
        const body = res;
        return body;
    }

    public handleDataWithHeaders(res: HttpResponse<any>) {
        const headers = res.headers;
        const body = res.body;
        const data = {
            headers: headers,
            body: body,
        };
        return data;
    }

    private handleError(error: any) {
        return Observable.throw(new HttpErrorResponse(error));
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/schedule.service.ts